import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "trip-calendar" }
const _hoisted_2 = { class: "trip-calendar__alert" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseCalendar = _resolveComponent("BaseCalendar")!
  const _component_BaseSpinner = _resolveComponent("BaseSpinner")!
  const _component_BaseAlert = _resolveComponent("BaseAlert")!
  const _component_BaseSection = _resolveComponent("BaseSection")!

  return (_openBlock(), _createBlock(_component_BaseSection, {
    errors: _ctx.v$.booking.$errors
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["trip-calendar__column", { 'disabled': _ctx.loading || _ctx.getIsLocked(_ctx.DirectionEnum.Outward) }])
        }, [
          _cache[4] || (_cache[4] = _createElementVNode("h4", null, "Outward date", -1)),
          (_openBlock(), _createBlock(_component_BaseCalendar, {
            onFromPage: _cache[0] || (_cache[0] = (e) => _ctx.handleFromPage(_ctx.DirectionEnum.Outward, e)),
            key: _ctx.outwardDate,
            modelValue: _ctx.outwardDate,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.outwardDate) = $event)),
            availableDates: _ctx.availableDatesOutward
          }, null, 8, ["modelValue", "availableDates"])),
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_BaseSpinner, {
                key: 0,
                size: 50
              }))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["trip-calendar__column", { 'disabled': _ctx.loading }])
        }, [
          _cache[5] || (_cache[5] = _createElementVNode("h4", null, "Return date", -1)),
          (_openBlock(), _createBlock(_component_BaseCalendar, {
            key: _ctx.returnDate,
            modelValue: _ctx.returnDate,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.returnDate) = $event)),
            availableDates: _ctx.availableDatesReturn,
            disabled: _ctx.tripType === _ctx.DirectionEnum.Outward,
            onFromPage: _cache[3] || (_cache[3] = (e) => _ctx.handleFromPage(_ctx.DirectionEnum.Return, e))
          }, null, 8, ["modelValue", "availableDates", "disabled"])),
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_BaseSpinner, {
                key: 0,
                size: 50
              }))
            : _createCommentVNode("", true)
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_2, [
        (_ctx.calendarNote)
          ? (_openBlock(), _createBlock(_component_BaseAlert, {
              key: 0,
              type: "info",
              message: _ctx.calendarNote
            }, null, 8, ["message"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["errors"]))
}